module.exports = __webpack_public_path__ + "static/img/1.06682c6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/3/1.png
// module id = Yd+J
// module chunks = 0